module.exports = __webpack_public_path__ + "img/2+pachet.27249773.png";